module.exports = __webpack_public_path__ + "img/income.9f115995.svg";